import { createHttpLink } from '@apollo/client'
import { getEnv } from '../env'

export const httpLink = createHttpLink({
  uri: getEnv('API_URL'),
})
